import { httpsCallable } from 'firebase/functions'
import { functions } from '@/config/firebase'

export interface CreateProfileRequest {
  eventType: string
  profileData: Record<string, any>
  roomId?: string
  roleId?: number
  imageBase64?: string
  imageFileName?: string
}

export interface ProfileDetailResponse {
  userId: string
  eventType: string
  prText: string
  isPrPublic: boolean
  isEmailPublic: boolean
  isTelPublic: boolean
  canViewPrivateInfo: boolean
  mailAddress: string
  username: string
  /** このルームの作成者(主催者)かどうか。room_id 指定時のみ意味を持つ */
  isRoomOwner?: boolean
  /** プロフィールが登録済みかどうか */
  isProfileRegistered?: boolean
  roomSubInfo: Array<{
    roomSubInfoId: string
    subValue: string
    propertyName: string
    propertyType: string
  }>
  bizName?: string
  bizCompanyName?: string
  bizPosition?: string
  bizContent?: string
  bizComment?: string
  bizTargetIndustry?: string
  bizExcludeIndustry?: string
  bizEmail?: string
  bizTel?: string
  bizPhotoUrl?: string
  loveNickname?: string
  loveAge?: number
  loveJob?: string
  loveGender?: string
  loveAnnualIncome?: string
  /** DBの love_wants_kids は文字列カラム（例: 'はい' / 'いいえ'） */
  loveWantsKids?: string
  loveTargetPerson?: string
  loveExcludePerson?: string
  loveContactInfo?: string
  loveTel?: string
  lovePhotoUrl?: string
  careerName?: string
  careerPrevCompany?: string
  careerLastPosition?: string
  careerEducationLevel?: string
  careerSchoolName?: string
  careerAge?: number
  careerGender?: string
  careerComment?: string
  careerTargetCompany?: string
  careerExcludeConditions?: string
  careerEmail?: string
  careerTel?: string
  careerPhotoUrl?: string
}

export const createProfile = async (request: CreateProfileRequest) => {
  try {
    const createProfileFunction = httpsCallable(functions, 'create_profile')
    const result = await createProfileFunction(request)
    return result.data
  } catch (error) {
    console.error('[createProfile] Error:', error)
    throw error
  }
}

export const updateProfile = async (request: CreateProfileRequest) => {
  try {
    const updateProfileFunction = httpsCallable(functions, 'update_profile')
    const result = await updateProfileFunction(request)
    return result.data
  } catch (error) {
    console.error('[updateProfile] Error:', error)
    throw error
  }
}

export const uploadProfileImage = async (request: {
  fileBase64: string
  fileName: string
  userId: string
  eventType: string
}) => {
  try {
    const uploadProfileImageFunction = httpsCallable(functions, 'upload_profile_image')
    const result = await uploadProfileImageFunction(request)
    return result.data
  } catch (error) {
    console.error('[uploadProfileImage] Error:', error)
    throw error
  }
}

export const getProfile = async (userId: string, roomId?: string): Promise<ProfileDetailResponse> => {
  try {
    const getProfileFunction = httpsCallable(functions, 'get_profile')
    const result = await getProfileFunction({ userId, roomId })
    return result.data as ProfileDetailResponse
  } catch (error) {
    console.error('[getProfile] Error:', error)
    throw error
  }
}

export const getProfileImage = async (
  userId: string,
  eventType?: string
): Promise<{ imageBase64: string | null; contentType: string | null }> => {
  try {
    const getProfileImageFunction = httpsCallable(functions, 'get_profile_image')
    const result = await getProfileImageFunction({ userId, eventType })
    return result.data as { imageBase64: string | null; contentType: string | null }
  } catch (error) {
    console.error('[getProfileImage] Error:', error)
    throw error
  }
}
